import { McButton, McModal } from '@maersk-global/mds-react-wrapper';
import React from 'react';

export const CarriersEditModal = ({
  closed,
  onConfirm,
  data,
}: {
  closed: () => void;
  onConfirm: () => void;
  data: unknown;
}) => {
  return (
    <McModal open closed={closed} dimension="medium" heading="Action Required">
      <div>
        There are weekly values manually adjusted that will not be overwritten by this update, please validate carrier's
        split individually in:
      </div>
      <ul>
        {(data as { weeks: string[] }).weeks.map((week, i) => (
          <li key={i}>{week}</li>
        ))}
      </ul>
      <McButton id="confirm" slot="primaryAction" appearance="primary" click={onConfirm} label="I will do it" />
    </McModal>
  );
};
